import { geometry } from '@progress/kendo-drawing';
import { TRANSPARENT } from '../constants.js';
import { VisualBase } from './VisualBase.js';
import { deepExtend } from '../utils/deep-extend.js';

const defaultOptions = {
    stroke: {
        color: TRANSPARENT,
        width: 0
    },
    fill: {
        color: 'black'
    }
};
class MarkerBase extends VisualBase {
    constructor(options) {
        options = deepExtend({}, defaultOptions, options);
        super(options);
        const anchor = this.options.anchor || {};
        this.anchor = new geometry.Point(anchor.x, anchor.y);
        this.createElement();
    }
    createElement() { }
    _transformToPath(point, path) {
        const transform = path.transform();
        if (point && transform) {
            point = point.transformCopy(transform);
        }
        return point;
    }
    redraw(options) {
        if (options) {
            if (options.position) {
                this.options.position = options.position;
            }
            super.redraw(options);
        }
    }
}

export { MarkerBase };
